export const styles = theme => ({
    emptyTypography: {
        fontSize: 14,
        marginTop: '20px',
        color: 'rgba(0, 0, 0, 0.40)',
    },
    itemPaper: {
        backgroundColor: 'white !important',
        marginBottom: '2px',
        padding: `${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px`,
        [theme.breakpoints.up('md')]: {
            padding: "25px 15px 25px 30px",
        }
    },
    badgeDiv: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: '1',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: '15px',
            flexGrow: 0,
        }
    },
    badgeLabel: {
        [theme.breakpoints.up('md')]: {
            marginLeft: '5px'
        }
    },
    desktopLink: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'inline',
        }
    },
    mobileLink: {
        display: 'inline',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        }
    },
    flexGrowDiv: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        }
    },

    itemsPaper: {
        marginBottom: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    itemDiv: {
        display: 'flex',
        padding: '20px',
        backgroundColor: 'white',
        marginBottom: 5,
        cursor: 'pointer'
    },
    brandText: {
        color: 'rgba(0, 0, 0, 0.5)',
    },
    buttonCard: {
        alignSelf: 'self-start',
        boxShadow: theme.shadows[2],
        borderRadius: '50%',
        paddingBottom: '0px',
        paddingTop: '0px',
        paddingLeft: 0,
        display: 'block',
        zIndex: 0,
        overflow: 'hidden',
    },
    addDialogFabButton: {
        position: 'fixed',
        bottom: 20,
        right: 20,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    cardList: {
        minHeight: 100,
        backgroundColor: '#fafafa',
        borderBottom: 'solid 1px #ddd',
    }
});
